import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { DialogService } from '../../../../core/services/dialog/dialog.service';
import { FamilyListComponent } from '../../molecules/family-list/family-list.component';

@Component({
  selector: 'app-family-container',
  templateUrl: './family-container.component.html',
  styleUrls: ['./family-container.component.scss'],
})
/**
 * Family Container Component
 */
export class FamilyContainerComponent implements OnInit {
  @ViewChild(FamilyListComponent) familyListComponent!: FamilyListComponent;

  labels = {
    title: 'family-list.title',
    addFamilyBtn: 'family-list.create-btn',
  };

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private dialogService: DialogService
  ) {}

  /**
   * @ngOnInit
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
  }

  /**
   * Open family form modal dialog in create mode
   */
  addNewFamilyOpenDialog() {
    this.dialogService.openFamilyFormModal(() => {
      this.familyListComponent.refresh();
    });
  }
}
